import { KeyValuePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem,MatMenuTrigger } from '@angular/material/menu';
import { TranslateService } from '@ngx-translate/core';

import { SettingsService } from '@core';

@Component({
    selector: 'app-translate',
    templateUrl: './translate.component.html',
    standalone: true,
    imports: [MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, KeyValuePipe]
})
export class TranslateComponent {
  langs = {
    'en-US': 'English',
    'de-de': 'German',
  };

  constructor(
    private translate: TranslateService,
    private settings: SettingsService
  ) {
    translate.addLangs(['en-US', 'de-de']);
  }

  useLanguage(language: string) {
    this.translate.use(language);
    this.settings.setLanguage(language);
  }
}
